import createIcon from '../../createIcon';

/**
 * @component @name StarRate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNDMgMTBMMTIgMkw5LjU3IDEwSDJMOC4xOCAxNC40MUw1LjgzIDIyTDEyIDE3LjMxTDE4LjE4IDIyTDE1LjgzIDE0LjQxTDIyIDEwSDE0LjQzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarRate = createIcon('StarRate', [
  [
    'path',
    {
      d: 'M14.43 10L12 2L9.57 10H2L8.18 14.41L5.83 22L12 17.31L18.18 22L15.83 14.41L22 10H14.43Z',
      key: '13ob3c',
    },
  ],
]);

export default StarRate;
